import React from 'react';
import { NSCard } from 'bricks';
import { numeralFormatter } from 'ns_libs/formatter';
import './StoryAreaBreakdown.scss';
import NSProFormaInput from 'bricks/NSProFormaInput/NSProFormaInput';

interface IStoryAreaBreakdownProps {
    storyAreas: (number | null)[];
    floorAreaVaries: boolean;
    onAreaChange: (story: number, area: number | null) => void;
    averageStories: number;
}

const StoryAreaBreakdown: React.FC<IStoryAreaBreakdownProps> = ({
    storyAreas,
    floorAreaVaries,
    onAreaChange,
    averageStories,
}) => {
    const totalArea = storyAreas.slice(0, Math.round(averageStories)).reduce((sum: number, area) => sum + (area || 0), 0);

    if (!floorAreaVaries) return null;

    const roundedAverageStories = Number.isFinite(averageStories) && averageStories > 0
        ? Math.round(averageStories)
        : 0;

    // Create array of story numbers based on averageStories
    const stories = Array.from({ length: roundedAverageStories }, (_, i) => i + 1);

    return (
        <NSCard className="NSCard--level-4 p-2 mb-2 StoryAreaBreakdown">
            <table className="w-100">
                <thead>
                    <tr>
                        <th className="text-left pb-1">Story</th>
                        <th className="text-left pb-1">Area</th>
                    </tr>
                </thead>
                <tbody>
                    {stories.map(story => (
                        <tr key={story}>
                            <td className="py-1">{story}</td>
                            <td className="text-right py-1">
                                <NSProFormaInput
                                    type="number"
                                    name={`story-area-${story}`}
                                    value={storyAreas[story - 1] === null ? '' : storyAreas[story - 1]}
                                    handleUpdateValue={(value: string | number) => {
                                        const newArea = value === '' ? null : Number(value);
                                        if (value === '' || !Number.isNaN(newArea)) {
                                            onAreaChange(story, newArea);
                                        }
                                    }}
                                    placeholder="Enter area"
                                    inputGroupClassName="p-0"
                                    min={0}
                                    appendInputAddon={<div className="px-2">ft²</div>}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <hr className="mt-1 mb-2" />
            <div className="d-flex justify-content-between">
                <div className="text-dark">Total</div>
                <div>
                    <span className="text-dark">
                        {numeralFormatter(totalArea, '0,0')}
                    </span>
                    <span className="ml-1">ft²</span>
                </div>
            </div>
        </NSCard>
    );
};

export default StoryAreaBreakdown;
